import { UPDATE_ORDER_STATUS_WIDGET } from "./actionTypes";

const initialState = {
  data : {}
};

const orderStatusWidget = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_ORDER_STATUS_WIDGET:
      state = { ...state, data: action.payload};
      break;
    
    default:
      break;
  }
  return state;
};

export default orderStatusWidget;
